import { z } from 'zod';
export const RoleSchema = z.enum(['super_admin', 'admin', 'manager', 'user']);
export const ROLE_HIERARCHY = {
    super_admin: 4,
    admin: 3,
    manager: 2,
    user: 1,
};
export function roleAtLeast(userRole, required) {
    return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[required];
}
//# sourceMappingURL=roles.js.map